import './style.css';

const Loading = ({ solid, size, padding }: { solid?: boolean, size?: number, padding?: number }) => {
  return (
    <div className="flex p-2" style={padding ? { padding: `${padding}px` } : {}}>
      <div className={`loading-circle${solid ? '' : ' opacity'} rounded-full md:w-2 md:h-2 bg-white mx-0.5`} style={{ width: `${size || 4}px`, height: `${size || 4}px` }} />
      <div className={`loading-circle${solid ? '' : ' opacity'} rounded-full md:w-2 md:h-2 bg-white mx-0.5`} style={{ width: `${size || 4}px`, height: `${size || 4}px`, animationDelay: '.4s' }} />
      <div className={`loading-circle${solid ? '' : ' opacity'} rounded-full md:w-2 md:h-2 bg-white mx-0.5`} style={{ width: `${size || 4}px`, height: `${size || 4}px`, animationDelay: '.8s' }} />
    </div>
  )
}

export default Loading